module.exports = __webpack_public_path__ + "img/image8.fa6753d0.jpg";